import axios from 'axios';
import request from './request.js'
import Vue from 'vue'
request.init();
const vue = new Vue();


Vue.prototype.$BaseUrl = "https://xyz.zjhylab.com/api"; //设置服务器默认值



// Warn if overriding existing method
if (Array.prototype.equals)
  // console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
  // if the other array is a falsy value, return
  if (!array)
    return false;
  // compare lengths - can save a lot of time
  if (this.length != array.length)
    return false;
  for (var i = 0, l = this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arrays
      if (!this[i].equals(array[i]))
        return false;
    } else if (this[i] != array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
}
// Hide method from for-in loops
//js格式化函数 日期
Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1,// month
    "d+": this.getDate(),// day
    "h+": this.getHours(),// hour
    "m+": this.getMinutes(),// minute
    "s+": this.getSeconds(),// second
    "q+": Math.floor((this.getMonth() + 3) / 3),// quarter
    "S": this.getMilliseconds()
    // millisecond
  };
  if (/(y+)/.test(format) || /(Y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};
//js格式化函数

Object.defineProperty(Array.prototype, "equals", {enumerable: false});

function GetDate(AddDayCount,AddHoursCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期
  if(AddHoursCount){
    dd.setHours(dd.getHours()+AddHoursCount);
  }else{
    dd.setHours(0);
  }

  dd.setMinutes(0);
  dd.setSeconds(0);
  return dd;

}


function GetOverView(row) {     //超标
  if (row.isover == true && row.isonline == true) {
    {
      return true;
    }
    return false;
  }
}

function GetWarnView(row) {   //预警
  if (row.iswarn == true && row.isover == false && row.isonline == true) {
    return true;
  }
  return false;
}

function GetOffLineView(row) {  //离线
  if (row.isonline == false) {
    return true;
  }
  return false;
}

function GetNormalView(row) {//正常
  if (row.isover == false && row.iswarn == false && row.isopen == true && row.isonline == true) {
    return true;
  }
  return false;
}


//异常
function GetMonitorAbnormalView(row) {
  if (row.isabnormal == true) {
    return true;
  }
  return false;
}

//超标
function GetMonitorOverView(row) {
  if (row.isover == true) {
    return true;
  }
  return false;
}

//预警
function GetMonitorWarnView(row) {
  if (row.isover == false && row.iswarn == true) {
    return true;
  }
  return false;
}

//正常
function GetMonitorNormalView(row) {
  if (row.isover == false && row.iswarn == false) {
    return true;
  }
  return false;
}

function fixedTo10(s) {
  return s < 10 ? '0' + s : s;
}
function variance(numbers) {
  var mean = 0;
  var sum = 0;
  for(var i=0;i<numbers.length;i++){
    sum += numbers[i];
  }
  mean = sum / numbers.length;
  sum = 0;
  for(var i=0;i<numbers.length;i++){
    sum += Math.pow(numbers[i] - mean , 2);
  }
  return sum / numbers.length;
}

function  std(ary) {
  if(ary.length==0){
    return 0;
  }
  let thisary = ary;　　//
  let  sumVal = function(x,y){ return x+y;};　　//求和函数
  let squareVal = function(x){ return x*x;};　　//数组中每个元素求它的平方
  let mean = thisary.reduce(sumVal)/thisary.length;

  let deviations = thisary.map(function(x){return x-mean;});
  let stddev = Math.sqrt(deviations.map(squareVal).reduce(sumVal)/(thisary.length-1));

  return stddev;
}







function getListMon(callback) {
  axios.get('https://monitor.hzjly.cn/api/MonitorObject/ListMonitorObject', {
    params: {parGuid: '', monitorObjectName: '', typeGuid: '', status: '', page: 1, pagesize: 0}
  })
    .then(function (response) {
      if (response.data.status == 101) {
      } else {
        var data = JSON.parse(response.data);
        if (data.results.rows) {
          callback(data.results.rows);
        } else {
          this.$message({
            message: data.results.data,
            type: 'warning'
          });
          callback(data.results.rows);
        }
      }

    })
    .catch(function (error) {
      callback(error);
    });
}

function getListDev(callback) {
  axios.get('https://monitor.hzjly.cn/api/Dev/ListDev', {
    params: {}
  })
    .then(function (response) {
      if (response.data.status == 101) {
      } else {
        var data = JSON.parse(response.data);
        if (data.results.rows) {
          callback(data.results.rows);
        } else {
          this.$message({
            message: data.results.data,
            type: 'warning'
          });
          callback(data.results.rows);
        }
      }

    })
    .catch(function (error) {
      callback(error);
    });
}

function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return "";
  }
}
function getSortFun(order, sortBy) {
  var ordAlpah = (order == 'asc') ? '>' : '<';
  var sortFun = new Function('a', 'b', 'return a.' + sortBy + ordAlpah + 'b.' + sortBy + '?1:-1');
  return sortFun;
}

function getStamp(val) {
  var data2 = val;
  data2 = data2.substring(0, 19);
  data2 = data2.replace(/-/g, '/');
  return new Date(data2).getTime();
}


function checkPower(str) {

  if (Vue.POWER.indexOf(str) > -1) {
    return true;
  } else {
    return false;
  }
}



//这几个方法应该是判断设备是否在国内外经纬度的
var x_PI = 3.14159265358979324 * 3000.0 / 180.0;
var PI = 3.1415926535897932384626;
var a = 6378245.0;
var ee = 0.00669342162296594323;
function out_of_china(lng, lat) {
  return (lng < 72.004 || lng > 137.8347) || ((lat < 0.8293 || lat > 55.8271) || false);
} //判断是否在国内，不在国内则不做偏移
function transformlat(lng, lat) {
  var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
  ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
  return ret
}
function transformlng(lng, lat) {
  var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
  ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
  return ret
}
//被导出的两个方法
function gcj02tobd09(lng, lat) {
  var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
  var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
  var bd_lng = z * Math.cos(theta) + 0.0065;
  var bd_lat = z * Math.sin(theta) + 0.006;
  return [bd_lng, bd_lat]
} //火星坐标转百度坐标
function wgs84togcj02(lng, lat) {
  if (out_of_china(lng, lat)) {
    return [lng, lat]
  }
  else {
    var dlat = transformlat(lng - 105.0, lat - 35.0);
    var dlng = transformlng(lng - 105.0, lat - 35.0);
    var radlat = lat / 180.0 * PI;
    var magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    var sqrtmagic = Math.sqrt(magic);
    dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
    dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
    var mglat = lat + dlat;
    var mglng = lng + dlng;
    return [mglng, mglat]
  }
} //WGS84转火星坐标

function removeEmptyArrayEle(arr){ //删除数组空元素
  for(var i = 0; i < arr.length; i++) {
    if(arr[i] == "undefined"||arr[i] ==undefined) {
      arr.splice(i,1);
      i = i - 1; // i - 1 ,因为空元素在数组下标 2 位置，删除空之后，后面的元素要向前补位，
      // 这样才能真正去掉空元素,觉得这句可以删掉的连续为空试试，然后思考其中逻辑
    }
  }
  return arr;
};
export {
  checkPower,
  GetDate,
  GetOverView,
  GetWarnView,
  GetOffLineView,
  GetNormalView,
  GetMonitorNormalView,
  GetMonitorWarnView,
  GetMonitorOverView,
  GetMonitorAbnormalView,
  getSortFun,
  getListDev,
  getCookie,
  getStamp,
  fixedTo10,
  variance,
  std,
  gcj02tobd09,
  wgs84togcj02,
  out_of_china,
  removeEmptyArrayEle,
}



// WEBPACK FOOTER //
// ./src/common/common.js